import useWidth from '@/hooks/useWidth'
import HeroPrev from '@/assets/hero-prev.png'
import { Col, Row } from '@prev/ui-kit'
import React from 'react'

const LoginHero = (): JSX.Element => {
  const width = useWidth()
  return (
    <Col span={14} xxl={14} xl={14} lg={14} md={14} sm={0} style={{ overflow: 'hidden' }} xs={0}>
      <Row
        style={{
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          height: '100%',
        }}
      >
        <img
          src={HeroPrev}
          alt="Prev logo"
          style={{
            width: width >= 1280 ? '100%' : '110%',
          }}
        />
      </Row>
    </Col>
  )
}

export default LoginHero
